import { create } from 'zustand';

/**
 * Browser-print fallback (spec §6, transport 3): render the receipt/KOT into a dedicated print
 * root and call window.print(). CSS in index.css hides everything else and sizes the page to
 * the paper width (58 mm / 80 mm). ESC/POS printing arrives in Phase 3.
 */
export const usePrintStore = create((set) => ({
  job: null, // { node, width }
  set: (job) => set({ job }),
}));

export function printNode(node, { width = '80mm' } = {}) {
  return new Promise((resolve) => {
    usePrintStore.getState().set({ node, width });
    // Let React render the print root, then open the dialog.
    requestAnimationFrame(() =>
      requestAnimationFrame(() => {
        const done = () => {
          window.removeEventListener('afterprint', done);
          usePrintStore.getState().set(null);
          resolve();
        };
        window.addEventListener('afterprint', done);
        window.print();
        // Some mobile browsers never fire afterprint.
        setTimeout(done, 60_000);
      }),
    );
  });
}
